<template>
  
</template>
<script>
import SearchParams from '@/lib/enums/SearchParams'

export default {
  data() {
    return {
      SearchParams: SearchParams,
      menu: false,
      openDrop: false
    }
  },
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    dataCy: {
      type: String,
      required: false,
      default: ''
    },
    selections: {
      type: Array,
      required: false,
      default: () => []
    },
    multipleChoice: {
      type: Boolean,
      required: false,
      default: true
    },
    disableBtn: {
      type: Boolean,
      required: false,
      default: false
    },
    hideSave: {
      type: Boolean,
      required: false,
      default: false
    },
    hideFooterBtn: {
      type: Boolean,
      required: false,
      default: false
    },
    filterDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    mobileView() {
      return (
        this.$vuetify.breakpoint.width < SearchParams.Constants.MinDisplayWidth
      )
    },
  },
  methods: {
    openFilter() {
      this.openDrop = !this.openDrop;
      this.$emit('checkSelections');
    },
    closeFilter() {
      this.openDrop = !this.openDrop;
      this.$emit('defaultSelections');
    },
    submitFilter() {
      this.$emit('submitFilter');
      this.openDrop = false;
    },
    cleanSelected() {
      this.$emit('cleanSelected');
      this.openDrop = false;
    },
    toggleMultiple() {
      this.$emit('toggleMultiple');
    }
  }
}
</script>


<style lang="scss" scoped>
.mobile-hdr {
  display: flex;
}

.filter-header {
  margin: 0 0 0 8px;
}
.filter-header .v-btn__content {
  height: 100%;
}

.v-btn--disabled.btn-not-selected {
  border: 1px solid #cccdce;
}

.btn-not-selected {
  background-color: white !important;
  color: black !important;
  border: 1px solid white;
}

.btn-selected {
  background-color: #ff7100 !important;
  color: #fff !important;
  border: 1px solid #ff7100;
}

.btn-selected,
.btn-not-selected {
  min-width: 90px !important;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  margin: 0px auto 6px;
  max-width: 175px;
  font-size: 14px;
  line-height: 1;
  color: white;
  text-align: center;
  width: 95%;
  height: 36px;
  border-radius: 18px;
  font-weight: normal;
}

#scrollbar-box {
  overflow-x: hidden;
  overflow-y: auto;
  height: 80vh;
}
#scrollbar-box .scrollbar-items {
  height: 245px;
}

#scrollbar-box .v-treeview-node__root {
  max-height: 20px;
}

.flex,
.child-flex > * {
  max-width: none;
}

.drop-down {
  background-color: #fff;
  width: 245px;
  margin: 0 auto;
}

.drop-down-cols {
  max-width: 450px;
  width: 450px;
  background-color: white;
}

.drop-down,
.drop-down-cols {
  padding-right: 5px;
  background-color: #ffffff;
  border-radius: 15px;
  border: 1px solid rgb(215, 215, 215);
  -webkit-box-shadow: 0 0 7px rgba(41, 41, 41, 0.11);
  -moz-box-shadow: 0 0 7px rgba(41, 41, 41, 0.11);
  box-shadow: 0 0 7px rgba(41, 41, 41, 0.11);
  overflow: hidden;
}

.drop-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
  padding: 10px 14px 11px 13px;
  margin-right: -7px;
  background-color: #f6f7f9;
}

.drop-footer {
  position: fixed;
  z-index: 10;
}

.drop-down-cols .drop-footer {
  flex-direction: row-reverse;
}

.drop-footer-btn .dr-btn-wrapper {
  width: fit-content;
  margin: 0 auto;
}

@media screen and (max-width: 768px) {
  .drop-down,
  .drop-down-cols {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    border-radius: 0;
    z-index: 102;
    padding: 9px 14px 0 16px;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
  }

  .drop-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 10;
  }

  #scrollbar-box .scrollbar-items {
    height: auto;
  }
}
@media only screen and (min-width: 600px) {
  .filter-header {
    margin: 0 5px;
  }
  .drop-footer {
    position: relative;
    z-index: 10;
  }

  #scrollbar-box {
    width: 90%;
    max-height: 330px;
    height: auto;
  }
}
</style>
